/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 * for rdpvcbridge vchan related enums
 * @format
 */

export enum VCWireMsgType {
   WireMsgNone = 0,
   WireMsgThunk,
   WireMsgConnect,
   WireMsgDisconnect,
   WireMsgData,
   WireMsgSessionInfoQuery,
   WireMsgSessionInfoResponse,
   WireMsgMax //only used for condition
}

export enum WTS_INFO_CLASS {
   WTSInitialProgram = 0,
   WTSApplicationName = 1,
   WTSWorkingDirectory = 2,
   WTSOEMId = 3,
   WTSSessionId = 4,
   WTSUserName = 5,
   WTSWinStationName = 6,
   WTSDomainName = 7,
   WTSConnectState = 8,
   WTSClientBuildNumber = 9,
   WTSClientName = 10,
   WTSClientDirectory = 11,
   WTSClientProductId = 12,
   WTSClientHardwareId = 13,
   WTSClientAddress = 14,
   WTSClientDisplay = 15,
   WTSClientProtocolType = 16,
   WTSIdleTime = 17,
   WTSLogonTime = 18,
   WTSIncomingBytes = 19,
   WTSOutgoingBytes = 20,
   WTSIncomingFrames = 21,
   WTSOutgoingFrames = 22,
   WTSClientInfo = 23,
   WTSSessionInfo = 24,
   WTSSessionInfoEx = 25,
   WTSConfigInfo = 26,
   WTSValidationInfo = 27,
   WTSSessionAddressV4 = 28,
   WTSIsRemoteSession = 29,
   WTSChannelOptions = 1000,
   WTSGetShortChannelName = 1001,
   WTSIsDynamicChannelRegistered = 1002,
   WTSGetRemoteSDKVersion = 1003,
   WTSIsNestedSession = 1004
}

export enum RDP_SVC_CHANNEL_OPTION {
   CHANNEL_OPTION_SHOW_PROTOCOL = 0x00200000,
   CHANNEL_OPTION_COMPRESS = 0x00400000,
   CHANNEL_OPTION_COMPRESS_RDP = 0x00800000,
   CHANNEL_OPTION_PRI_LOW = 0x02000000,
   CHANNEL_OPTION_PRI_MED = 0x04000000,
   CHANNEL_OPTION_PRI_HIGH = 0x08000000,
   CHANNEL_OPTION_ENCRYPT_CS = 0x10000000,
   CHANNEL_OPTION_ENCRYPT_SC = 0x20000000,
   CHANNEL_OPTION_ENCRYPT_RDP = 0x40000000,
   CHANNEL_OPTION_INITIALIZED = 0x80000000
}
